export default {"container":"EUaS4G_container","heading":"EUaS4G_heading","hero":"EUaS4G_hero","icon":"EUaS4G_icon","leading":"EUaS4G_leading",}